"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var photo_1 = require("./photo");
var classNames = require("classnames");
var I18n = require("i18n-js");
var lodash_1 = require("lodash");
var bind_1 = require("../../bind");
var humps_1 = require("humps");
var defaultDropZoneSelector = 'body';
var Uploader = /** @class */ (function (_super) {
    tslib_1.__extends(Uploader, _super);
    function Uploader(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isUploading: false,
            isDragging: false,
            progress: 0,
        };
        return _this;
    }
    Uploader.prototype.componentDidMount = function () {
        var _this = this;
        var uploadOptions = this.props.uploadOptions;
        var $dropZone = $(this.props.dropZoneSelector || defaultDropZoneSelector);
        var options = {
            url: lodash_1.get(uploadOptions, 'html.data.url'),
            formData: lodash_1.get(uploadOptions, 'html.data.form_data'),
            dataType: 'json',
            paramName: 'file',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            sequentialUploads: true,
            acceptFileTypes: /^image\/jpeg|image\/png|image\/heic|image\/heif$/i,
            done: function (_e, data) { return _this.handleUploadSuccess(data.result); },
            fail: this.props.onUploadFailure,
            always: this.handleUploadDone,
            send: this.handleUploadStart,
            progressall: function (_e, data) { return _this.handleProgress(data); },
            dropZone: $dropZone,
            dragover: this.handleDragOver,
        };
        this.bindDragLeave();
        $(this.refs.input).fileupload(options);
    };
    Uploader.prototype.bindDragLeave = function () {
        var _this = this;
        $(document).on('dragleave', this.props.dropZoneSelector, function () {
            // Set isDragging to false. If it is still false in 10ms, then we have actually
            // left the window. Otherwise this may be called when dragging into other elements
            // on the page, in which case isDragging will have been set back to true.
            _this.setState({ isDragging: false });
            setTimeout(function () {
                if (!_this.state.isDragging) {
                    _this.handleDragLeave();
                }
            }, 10);
        });
    };
    Uploader.prototype.handleUploadStart = function () {
        this.setState({
            isUploading: true,
            progress: 0,
        });
        this.handleDragLeave();
    };
    Uploader.prototype.handleUploadSuccess = function (result) {
        var camelized = humps_1.camelizeKeys(result);
        this.props.onFileAdded(new photo_1.default(camelized));
        this.handleUploadDone();
    };
    Uploader.prototype.handleUploadDone = function () {
        this.setState({ isUploading: false });
    };
    Uploader.prototype.handleProgress = function (data) {
        var progress = data.loaded / data.total * 100;
        this.setState({ progress: progress });
    };
    Uploader.prototype.handleDragOver = function () {
        this.setState({ isDragging: true });
        this.props.onDragStart();
    };
    Uploader.prototype.handleDragLeave = function () {
        this.setState({ isDragging: false });
        this.props.onDragEnd();
    };
    Uploader.prototype.renderLabel = function () {
        if (this.state.isUploading) {
            var percent = this.state.progress.toFixed(0);
            return I18n.t('discovery.photos.uploader.progress', { percent: percent });
        }
        return I18n.t('discovery.photos.uploader.uploadPhotos');
    };
    Uploader.prototype.render = function () {
        var className = classNames('img-uploader__thumb', 'img-uploader__thumb--add-photo', { 'img-uploader__thumb--add-photo--active': !this.state.isUploading });
        return (React.createElement("div", { className: className },
            React.createElement("div", { className: "img-uploader__thumb__message" },
                React.createElement("label", null, this.renderLabel())),
            React.createElement("input", { ref: "input", type: "file", accept: "image/jpeg,image/png,image/heic", multiple: lodash_1.get(this.props.uploadOptions, 'html.multiple') })));
    };
    Uploader.defaultProps = {
        dropZoneSelector: defaultDropZoneSelector,
        onUploadFailure: function () { },
    };
    tslib_1.__decorate([
        bind_1.default
    ], Uploader.prototype, "handleUploadStart", null);
    tslib_1.__decorate([
        bind_1.default
    ], Uploader.prototype, "handleUploadSuccess", null);
    tslib_1.__decorate([
        bind_1.default
    ], Uploader.prototype, "handleUploadDone", null);
    tslib_1.__decorate([
        bind_1.default
    ], Uploader.prototype, "handleProgress", null);
    tslib_1.__decorate([
        bind_1.default
    ], Uploader.prototype, "handleDragOver", null);
    tslib_1.__decorate([
        bind_1.default
    ], Uploader.prototype, "handleDragLeave", null);
    return Uploader;
}(React.Component));
exports.default = Uploader;
//# sourceMappingURL=uploader.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/photos/uploader.js
// module id = GkNk
// module chunks = 20 21